import { render, staticRenderFns } from "./Podio.vue?vue&type=template&id=1050459d&lang=pug&"
import script from "./Podio.vue?vue&type=script&lang=js&"
export * from "./Podio.vue?vue&type=script&lang=js&"
import style0 from "./Podio.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports